import React from "react";
import "./Loader.scss";

export const Loader = ({ message }: { message?: string }): JSX.Element => {
  return (
    <div className="loader-over">
      <div className="message">{message}</div>
      <div className="loader" />
    </div>
  );
};
